<script>
import { mapGetters } from 'vuex'
import NavHeader from '../components/simulator/arce/NavHeader'
import StepsArce from '../components/simulator/arce/StepsArce'
import stepsMixin from '../mixins/stepsMixin'
import userActions from '@/mixins/actionsMixin'

export default {
	mixins: [stepsMixin, userActions],
	components: {
		SvgIcon: () => import('../components/SvgIcon'),
		HeaderLayout: () => import('../components/simulator/arce/HeaderLayout'),
		NavHeader: NavHeader,
		StepsArce: StepsArce,
		ArceWizard: () => import('@/components/simulator/arce/ArceWizard'),
		ClientSearch: () => import('@/components/simulator/arce/ClientSearch'),
		GroupStructure: () => import('@/components/simulator/arce/GroupStructure')
	},
	data() {
		return {
			steps:  [
				{
					target: '[data-v-step="0"]',  // We're using document.querySelector() under the hood
					header: {
					title: 'Get Started',
					},
					content: `Discover <strong>Vue Tour</strong>!`
				},
				{
					target: '[data-v-step="1"]',
					content: 'An awesome plugin made with Vue.js!'
				},
				{
					target: '[data-v-step="2"]',
					content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
					params: {
					placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
					}
				}
			]
		}
	},
	computed: {
		...mapGetters({
			showArceWizard: 'arceStatus/showArceWizard',
			showSearchClient: 'arceStatus/showSearchClient',
			arce: 'arceDetails/arce',
		})
	},
}
</script>
<template>
	<div class="s-wrap" style="font-size: 0.9em" @click="saveTimeUserBack()">
		
		<HeaderLayout />
		<main class="s-main">
			<div class="s-main__nav ">
		<div class="s-main__nav-item px-3 pb-1">
			<div class="slds-icon-waffle_container">
				<div class="slds-icon-waffle"><div class="slds-r1"></div><div class="slds-r2"></div><div class="slds-r3"></div><div class="slds-r4"></div><div class="slds-r5"></div><div class="slds-r6"></div><div class="slds-r7"></div><div class="slds-r8"></div><div class="slds-r9"></div></div>
			</div>
			<span class="ml-3">Ventas BBVA</span>
		</div>
		<ul class="s-nav">
			<li>
				<router-link :to="{name: 'arce-index'}" class="s-nav__item" :class="{'s-nav__item--active': $route.name.includes('arce-index')}">Inicio</router-link>
			</li>
			<li>
				<router-link :to="{name: 'arce-clients'}" class="s-nav__item" :class="{'s-nav__item--active': $route.name.includes('client')}" data-v-step="0">Clientes
					<span class="s-nav__icon mt-1">
						<svg-icon name="chevrondown" />
					</span>
				</router-link> 
				
			</li>
			<li>
				<router-link :to="{name: 'arce-details-list'}" class="s-nav__item" :class="{'s-nav__item--active': $route.name.includes('details')}" data-v-step="0">ARCE </router-link> 
			</li>
			
			<li>
				<a href="#" class="s-nav__item">Oportunidades</a>
			</li>
			<li>
				<a href="#" class="s-nav__item">Alerta CRM</a>
			</li>
			<li>
				<a href="#" class="s-nav__item">Paneles</a>
			</li>
			<li>
				<a href="#" class="s-nav__item">Informes</a>
			</li>
			<li>
				<a href="#" class="s-nav__item">Metas de visitas</a>
			</li>
		</ul>
	</div>
			<div class="s-main__content">
				<div class="s-main__wrap">
					<router-view></router-view>
				</div>
			</div>
		</main>
		<ClientSearch v-if="showSearchClient"  />
		<ArceWizard v-if="showArceWizard" />
		<GroupStructure v-if="arce" :arce="arce"/>

		<StepsArce />

		<notifications position="top center" width="500px"  group="simulator">
			<template slot="body" slot-scope="props">
				<div class="s-notification" :class="props.item.type">
					<div class="p-2 s-notification__icon">
						<i v-if="props.item.type == 'success'" class="fa fa-check-circle" aria-hidden="true"></i>
						<i v-if="props.item.type == 'warn'" class="fa fa-exclamation-triangle"></i>
					</div>
					<div class="flex-grow-1">
						<p class="title m-0">
						{{props.item.title}}
						</p>
						<div class="m-0" v-html="props.item.text">
						</div>
					</div>
					<a class="close" @click="props.close">
						<i class="fa fa-fw fa-close"></i>
					</a>
					
				</div>
  			</template>
		</notifications>

		<!-- <footer class="s-footer"></footer>
		 -->
		<!-- <svg lightning-primitiveIcon_primitiveIcon="" focusable="false" data-key="down" aria-hidden="true" class="slds-icon slds-icon-text-default slds-icon_xx-small"><use lightning-primitiveIcon_primitiveIcon="" xlink:href="../assets/simulator/symbols.svg?cache=9.36.1#down"></use></svg> -->
	</div>
</template>
<style lang="scss">
@import '../assets/scss/simulator/index.scss';
</style>
<style lang="scss" scoped>
</style>